"use client";

import { devLabel, devLabelPanel } from "@/lib/dev-labels";
import { PLATFORMS } from "./platforms";
import styles from "./ExportModal.module.css";

/**
 * PlatformPresetSelector — Phase 25-AB Task 12 (panel 21-B).
 *
 * Mockup source: docs/mockups/export.html lines 558-571.
 * 8 platform chips. Multi-select supported (each platform gets its own
 * export run with the right aspect/duration). Selecting a chip also
 * notifies the host so it can auto-select the recommended format.
 */

export interface PlatformPresetSelectorProps {
	selected: string[]; // array of platform keys
	onToggle: (key: string) => void;
}

export function PlatformPresetSelector({
	selected,
	onToggle,
}: PlatformPresetSelectorProps) {
	const selectedSet = new Set(selected);

	return (
		<div
			className={styles.rightBlock}
			data-testid="platform-presets"
			{...devLabelPanel("21-B")}
		>
			<div className={styles.rightTitle}>플랫폼 프리셋</div>
			<div className={styles.platformGrid}>
				{PLATFORMS.map((p) => {
					const on = selectedSet.has(p.key);
					return (
						<button
							type="button"
							key={p.key}
							className={[styles.plat, on ? styles.platOn : ""]
								.filter(Boolean)
								.join(" ")}
							onClick={() => onToggle(p.key)}
							aria-pressed={on}
							aria-label={`${p.name} (${p.aspect}, ${p.resolution.w}×${p.resolution.h}, ${p.maxDuration}초)`}
							data-testid={`platform-${p.key}`}
							{...devLabel(p.dev)}
						>
							<span className={styles.platName}>{p.name}</span>
							<span className={styles.platMeta}>
								{p.aspect} · {p.maxDuration}s
							</span>
						</button>
					);
				})}
			</div>
			<div className={styles.platHint}>
				선택 시 화면비/길이 자동 적용. 멀티 선택 가능 (각 플랫폼 별도 export).
			</div>
		</div>
	);
}
